// @ts-ignore
import { getUserData } from "@/auth/getUserData";
import axios from "@/libs/axios";
import { useChatsStore } from "@/store/useChatsStore";
// @ts-ignore
import useActiveChat from "@/views/modules/messaging-inbox/useActiveChat";
import { ref } from "@vue/composition-api";
import { storeToRefs } from "pinia";

const activeTabIndex = ref(null);
const activeChatTemplatesTab = ref("");
const isManageTemplatePanelActive = ref(false);
const isTemplate = ref(false);
const isQuickReply = ref(false);
const hasMediaTemplateFilesUploaded = ref(false);
const availableVariables = [
    "{{agent.name}}",
    "{{agent.displayname}}",
    "{{customer.fullname}}",
    "{{customer.email}}",
    "{{customer.reference}}",
    "{{customer.jobtitle}}",
    "{{customer.company}}",
    "{{customer.phone}}",
];

const selectedTemplate = ref({
    id: null,
    content: "",
    mediaType: "",
    final: "",
    variables: [],
    components: null,
});

// @ts-ignore
export default function useActiveChatTemplates() {
    const chatsStore = useChatsStore();
    const { activeChat } = storeToRefs(chatsStore);

    // @ts-ignore
    const fetchVariablesFromContent = (content) => {
        const variables = content.match(/\{\{([^}]+)\}\}/g);

        if (!variables) {
            return;
        }

        // @ts-ignore
        return content.match(/\{\{([^}]+)\}\}/g).map((variable, index) => {
            return {
                index: index + 1,
                name: variable,
                value: variable,
            };
        });
    };

    // Minus 1, because template variables starts with 1, not 0 which is the array start index.
    // @ts-ignore
    const replaceVariablesByArray = (templateString, replacementValues) => {
        // @ts-ignore
        return templateString.replace(/{{\s*([^}]*)\s*}}/g, (_, $1) => replacementValues[$1 - 1]);
    };

    // @ts-ignore
    const variablesToIndex = (templateString) => {
        let index = 1;
        return templateString.replace(/{{\s*([^}]*)\s*}}/g, () => {
            const i = index;

            index++;

            return `{{${i}}}`;
        });
    };

    // @ts-ignore
    const replaceVariablesByObject = (templateString, replacementValuesObject) => {
        return templateString.replace(
            /{{\s*([^}]*)\s*}}/g,
            // @ts-ignore
            (variable, $1) => replacementValuesObject[variable] ?? variable
        );
    };

    // Map the values of specific variables and return the object.
    const mapVariablesValues = (contactId?: number) => {
        // We don't have all contact data yet, so we'll do a separate request to fetch all needed data.
        return (
            axios
                .get(`/contacts/${contactId ?? activeChat.value?.contact.id}`, {
                    params: {
                        fields: "name,email,reference,jobTitle,company,phone",
                    },
                })
                // @ts-ignore
                .then((contact) => {
                    return {
                        "{{agent.name}}": getUserData().name,
                        "{{agent.displayname}}": getUserData().displayName,
                        "{{customer.fullname}}": contact.data.name,
                        "{{customer.email}}": contact.data.email,
                        "{{customer.reference}}": contact.data.reference,
                        "{{customer.jobtitle}}": contact.data.jobTitle,
                        "{{customer.company}}": contact.data.company,
                        "{{customer.phone}}": contact.data.phone,
                    };
                })
        );
    };

    const resetTemplate = () => {
        // @ts-ignore
        selectedTemplate.value = {};
        isTemplate.value = false;
        isQuickReply.value = false;
        hasMediaTemplateFilesUploaded.value = false;
    };

    return {
        selectedTemplate,
        activeChatTemplatesTab,
        availableVariables,
        isManageTemplatePanelActive,
        isTemplate,
        isQuickReply,
        hasMediaTemplateFilesUploaded,

        // Methods
        fetchVariablesFromContent,
        mapVariablesValues,
        replaceVariablesByArray,
        replaceVariablesByObject,
        resetTemplate,
        variablesToIndex,

        activeTabIndex,
    };
}
